
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"t80sb3s6pa","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"12","height":"12"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h12v12H0z"}})]),_c('g',{attrs:{"mask":"url(#t80sb3s6pa)"}},[_c('path',{attrs:{"d":"M4.3 11.25l-.95-1.6-1.8-.4.175-1.85L.5 6l1.225-1.4-.175-1.85 1.8-.4.95-1.6 1.7.725L7.7.75l.95 1.6 1.8.4-.175 1.85L11.5 6l-1.225 1.4.175 1.85-1.8.4-.95 1.6-1.7-.725-1.7.725zm1.175-3.475L8.3 4.95l-.7-.725L5.475 6.35 4.4 5.3l-.7.7 1.775 1.775z","fill":"#0091DA"}})])])
          )
        }
      }
    